import tokenStore from "./tokenStore";

// Session timing resolution order: value the backend sent at login/refresh →
// env override → hard default (30 min idle / 2 min warning, mirroring the
// backend defaults). Nothing else in the app should hardcode these numbers.

export interface SessionConfig {
  idleTimeoutSec: number;
  warningBeforeSec: number;
  accessTokenExpiresIn: number;
}

const DEFAULTS: SessionConfig = {
  idleTimeoutSec: 1800,
  warningBeforeSec: 120,
  accessTokenExpiresIn: 1800,
};

const envNumber = (value: string | undefined): number | undefined => {
  const n = value ? parseInt(value, 10) : NaN;
  return Number.isFinite(n) && n > 0 ? n : undefined;
};

// Crash-proof under both bundlers: CRA injects a real process.env object;
// Vite's env-compatible plugin may only substitute static references — a
// missing binding must degrade to the defaults, never throw.
const readEnv = (key: string): string | undefined => {
  try {
    return (process.env as Record<string, string | undefined>)[key];
  } catch {
    return undefined;
  }
};

export function getSessionConfig(): SessionConfig {
  const stored = tokenStore.getStoredSessionConfig();
  return {
    idleTimeoutSec:
      stored?.idleTimeoutSec ||
      envNumber(readEnv("REACT_APP_SESSION_IDLE_TIMEOUT_SEC")) ||
      DEFAULTS.idleTimeoutSec,
    warningBeforeSec:
      stored?.warningBeforeSec ||
      envNumber(readEnv("REACT_APP_SESSION_WARNING_BEFORE_SEC")) ||
      DEFAULTS.warningBeforeSec,
    accessTokenExpiresIn:
      stored?.accessTokenExpiresIn || DEFAULTS.accessTokenExpiresIn,
  };
}
